import { render, staticRenderFns } from "./AddDecoration.vue?vue&type=template&id=df520486&scoped=true&"
import script from "./AddDecoration.vue?vue&type=script&lang=js&"
export * from "./AddDecoration.vue?vue&type=script&lang=js&"
import style0 from "./AddDecoration.vue?vue&type=style&index=0&id=df520486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df520486",
  null
  
)

export default component.exports